"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MultipleActionsBlock: ['multiple-actions-block', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M13.008 21.491L21.492 13.007', 'M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsVideo: ['multiple-actions-video', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M23.25,15.75l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z']],
  MultipleActionsCreditCard: ['multiple-actions-credit-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M11.250 14.250 L23.250 14.250 L23.250 23.250 L11.250 23.250 Z', 'M11.25 17.25L23.25 17.25', 'M17.25 20.25L20.25 20.25']],
  MultipleActionsAddress: ['multiple-actions-address', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M15.000 17.250 A2.250 2.250 0 1 0 19.500 17.250 A2.250 2.250 0 1 0 15.000 17.250 Z', 'M19.5,17.25v1.125a1.874,1.874,0,0,0,1.875,1.875h0a1.874,1.874,0,0,0,1.875-1.875v-.847a6.185,6.185,0,0,0-5.845-6.276,6,6,0,0,0-1.577,11.835,6.14,6.14,0,0,0,2.966-.038']],
  MultipleActionsAdd: ['multiple-actions-add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 14.25L17.25 20.25', 'M14.25 17.25L20.25 17.25', 'M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsAlarm: ['multiple-actions-alarm', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M18,12a3.75,3.75,0,0,1,3.75,3.75v3a1.5,1.5,0,0,0,1.5,1.5H12.75a1.5,1.5,0,0,0,1.5-1.5v-3A3.75,3.75,0,0,1,18,12Z', 'M18,22.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,22.5']],
  MultipleActionsCheck1: ['multiple-actions-check-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.782,10.516A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.128 A3.375 3.375 0 1 0 10.125 4.128 A3.375 3.375 0 1 0 3.375 4.128 Z', 'M13.875 3.378 A2.625 2.625 0 1 0 19.125 3.378 A2.625 2.625 0 1 0 13.875 3.378 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M11.250 17.247 A6.000 6.000 0 1 0 23.250 17.247 A6.000 6.000 0 1 0 11.250 17.247 Z', 'M19.924,15.5l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5']],
  MultipleActionsCoding: ['multiple-actions-coding', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75 15.75L14.25 17.25 15.75 18.75', 'M18.75 15.75L20.25 17.25 18.75 18.75']],
  MultipleActionsChat: ['multiple-actions-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.5,9.645A6.111,6.111,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.823,8.25a4.446,4.446,0,0,0-6.66,0', 'M21.75,20.25h-3l-4.5,3v-3h-1.5a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v6A1.5,1.5,0,0,1,21.75,20.25Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25']],
  MultipleActionsCart: ['multiple-actions-cart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M23.25,12l-2.821,7.756a.751.751,0,0,1-.7.494H14.357a.752.752,0,0,1-.69-.455L12.06,15.3a.749.749,0,0,1,.69-1.045h9.681', 'M15.375,22.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,22.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  MultipleActionsFlash: ['multiple-actions-flash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25A6,6,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M18.678,7.312a4.5,4.5,0,0,0-5.566.978', 'M20.25,9.75l-5.911,6.882a.375.375,0,0,0,.286.618H17.25v6l5.911-6.882a.376.376,0,0,0-.286-.618H20.25Z']],
  MultipleActionsFlight: ['multiple-actions-flight', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.784,10.513A6.05,6.05,0,0,0,6.752,9a6,6,0,0,0-6,5.25', 'M3.377 4.125 A3.375 3.375 0 1 0 10.127 4.125 A3.375 3.375 0 1 0 3.377 4.125 Z', 'M13.877 3.375 A2.625 2.625 0 1 0 19.127 3.375 A2.625 2.625 0 1 0 13.877 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M21.872,13.623a1.756,1.756,0,0,1,1,.633,1.8,1.8,0,0,1-.447,2.6l-10.142,6.3a.624.624,0,0,1-.688-.02l-3.718-2.61a.343.343,0,0,1-.052-.483c.017-.022,1.619-1.434,1.619-1.434a.342.342,0,0,1,.331-.057l1.956,1.165,2.48-1.73-4.7-2.91a.427.427,0,0,1-.048-.6c.02-.024,1.217-.916,1.217-.916a.425.425,0,0,1,.4-.057l6.477,2.411,3-2.045A1.671,1.671,0,0,1,21.872,13.623Z']],
  MultipleActionsHome: ['multiple-actions-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.049,6.049,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.124 A3.375 3.375 0 1 0 10.125 4.124 A3.375 3.375 0 1 0 3.375 4.124 Z', 'M13.875 3.374 A2.625 2.625 0 1 0 19.125 3.374 A2.625 2.625 0 1 0 13.875 3.374 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.709', 'M12.75,15.947v5.8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-5.8', 'M11.25,17.26l4.518-3.954a2.25,2.25,0,0,1,2.963,0L23.25,17.26', 'M18.75,23.249h-3v-3a1.5,1.5,0,1,1,3,0Z']],
  MultipleActionsImage: ['multiple-actions-image', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.749,9.778A6.1,6.1,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.375,14.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M23.25,21l-2.391-3.587A.75.75,0,0,0,19.62,17.4l-2,2.851-1.236-.989a.751.751,0,0,0-1.093.17L12.75,23.25']],
  MultipleActionsHeart: ['multiple-actions-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,23.25l-5.114-5.335a3.025,3.025,0,0,1-.567-3.492h0a3.026,3.026,0,0,1,4.846-.787l.835.835.835-.835a3.025,3.025,0,0,1,4.845.787h0a3.027,3.027,0,0,1-.566,3.492Z', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsMail: ['multiple-actions-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75v6a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-6', 'M23.25,15.75a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5L16.455,19a1.5,1.5,0,0,0,1.59,0Z', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M11.452,11.245A6.051,6.051,0,0,0,.75,14.25', 'M21,11.25A4.484,4.484,0,0,0,12.963,8.5']],
  MultipleActionsLocation: ['multiple-actions-location', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.519A6.048,6.048,0,0,0,6.75,9.006a6,6,0,0,0-6,5.25', 'M3.375 4.131 A3.375 3.375 0 1 0 10.125 4.131 A3.375 3.375 0 1 0 3.375 4.131 Z', 'M13.875 3.381 A2.625 2.625 0 1 0 19.125 3.381 A2.625 2.625 0 1 0 13.875 3.381 Z', 'M20.4,9.006a4.5,4.5,0,0,0-7.284-.71', 'M18.75,15.443a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M18.75,11.318a4.5,4.5,0,0,1,4.5,4.5c0,1.92-2.688,5.576-3.909,7.138a.751.751,0,0,1-1.183,0c-1.221-1.561-3.908-5.217-3.908-7.137A4.5,4.5,0,0,1,18.75,11.318Z']],
  MultipleActionsLock: ['multiple-actions-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25A6,6,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.888,8.29a4.5,4.5,0,0,0-6.776,0', 'M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75 19.154L18.75 19.154', 'M18.75,19.154a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375']],
  MultipleActionsLaptop: ['multiple-actions-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.9,9.78A6.093,6.093,0,0,0,6.9,9a6,6,0,0,0-6,5.25', 'M3.520 4.125 A3.375 3.375 0 1 0 10.270 4.125 A3.375 3.375 0 1 0 3.520 4.125 Z', 'M14.020 3.375 A2.625 2.625 0 1 0 19.270 3.375 A2.625 2.625 0 1 0 14.020 3.375 Z', 'M20.541,9a4.5,4.5,0,0,0-7.284-.71', 'M21.9,12.75v6H11.4v-6a1.5,1.5,0,0,1,1.5-1.5h7.5A1.5,1.5,0,0,1,21.9,12.75Z', 'M11.4,18.75H21.9l1.171,3.513a.751.751,0,0,1-.712.987H10.935a.75.75,0,0,1-.711-.987Z']],
  MultipleActionsMusic: ['multiple-actions-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M12.000 21.375 A1.875 1.875 0 1 0 15.750 21.375 A1.875 1.875 0 1 0 12.000 21.375 Z', 'M19.500 19.125 A1.875 1.875 0 1 0 23.250 19.125 A1.875 1.875 0 1 0 19.500 19.125 Z', 'M15.75,21.375V14.581a1.5,1.5,0,0,1,1.026-1.423l4.5-1.25a1.5,1.5,0,0,1,1.974,1.423v5.794']],
  MultipleActionsMonitor: ['multiple-actions-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.753,9.78a6.093,6.093,0,0,0-3-.78,6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M11.250 11.250 L23.250 11.250 L23.250 20.250 L11.250 20.250 Z', 'M14.25 23.25L20.25 23.25', 'M17.25 23.25L17.25 20.25']],
  MultipleActionsPlayer: ['multiple-actions-player', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.749,9.778A6.1,6.1,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.75,17.25V15.43a.43.43,0,0,1,.651-.369l3.034,1.82a.431.431,0,0,1,0,.738L16.4,19.439a.43.43,0,0,1-.651-.369Z']],
  MultipleActionsRefresh: ['multiple-actions-refresh', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15 18.75L11.25 18.75 11.25 22.5', 'M22.667,19.483a5.572,5.572,0,0,1-10.74-.733', 'M19.5 15.75L23.25 15.75 23.25 12', 'M11.832,15.017a5.572,5.572,0,0,1,10.74.733', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsStar: ['multiple-actions-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.968,11.68,19.509,15h2.979a.735.735,0,0,1,.518,1.283l-2.582,2.562,1.442,3.314a.786.786,0,0,1-1.119.982l-3.486-1.961-3.487,1.961a.786.786,0,0,1-1.119-.982L14.1,18.848l-2.6-2.562A.734.734,0,0,1,12.009,15h3l1.544-3.323A.8.8,0,0,1,17.968,11.68Z', 'M11.832,11.733A6.021,6.021,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsShield: ['multiple-actions-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75a7.669,7.669,0,0,1-6,7.5,7.668,7.668,0,0,1-6-7.5v-3a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5Z', 'M17.25 15L17.25 19.5', 'M15 17.25L19.5 17.25', 'M9.5,9.645A6.094,6.094,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.822,8.25a4.445,4.445,0,0,0-6.659,0']],
  MultipleActionsSubtract: ['multiple-actions-subtract', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z', 'M14.25 17.249L20.25 17.249', 'M10.782,10.514A6.053,6.053,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsUpload: ['multiple-actions-upload', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 14.25', 'M17.25 14.25L15 16.5', 'M17.25 14.25L19.5 16.5', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsTime: ['multiple-actions-time', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.901 17.25L17.25 17.25 17.25 14.598', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsText: ['multiple-actions-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.5,9.645A6.111,6.111,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.823,8.25a4.446,4.446,0,0,0-6.66,0', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25', 'M14.25 20.25L16.5 20.25']],
  MultipleActionsWifi: ['multiple-actions-wifi', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M17.25,22.424a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M23.25,15.622a9.542,9.542,0,0,0-12,0', 'M13.749,19.238a5.567,5.567,0,0,1,7,0']],
  MultipleActionsWarning: ['multiple-actions-warning', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,20.25a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M17.25 18L17.25 15', 'M23.062,20.682a1.774,1.774,0,0,1-1.587,2.568H13.024a1.774,1.774,0,0,1-1.587-2.568l4.226-8.452a1.774,1.774,0,0,1,3.173,0Z', 'M11.6,11.4A6.029,6.029,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsCheck2: ['multiple-actions-check-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,17.25a6,6,0,1,1-6-6', 'M23.25,12.749l-5.47,5.47a.749.749,0,0,1-1.06,0L15,16.5', 'M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsFlag: ['multiple-actions-flag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.739,9.739A4.5,4.5,0,0,0,13.112,8.29', 'M11.25,11.008A6.051,6.051,0,0,0,.75,14.25', 'M14.25 12.75H23.25V18.75H14.25z', 'M14.25 12.75L14.25 23.25']],
  MultipleActionsDownload: ['multiple-actions-download', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z', 'M17.25 14.249L17.25 20.249', 'M17.25 20.249L15 17.999', 'M17.25 20.249L19.5 17.999', 'M10.781,10.513A6.049,6.049,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.124 A3.375 3.375 0 1 0 10.125 4.124 A3.375 3.375 0 1 0 3.375 4.124 Z', 'M13.875 3.374 A2.625 2.625 0 1 0 19.125 3.374 A2.625 2.625 0 1 0 13.875 3.374 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.709']],
  MultipleActionsGraduate: ['multiple-actions-graduate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.968,12.61A5.873,5.873,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.124 A3.375 3.375 0 1 0 10.125 4.124 A3.375 3.375 0 1 0 3.375 4.124 Z', 'M13.875 3.374 A2.625 2.625 0 1 0 19.125 3.374 A2.625 2.625 0 1 0 13.875 3.374 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.709', 'M16.5 14.307L9.75 17.087 16.5 19.557 23.25 17.087 16.5 14.307z', 'M9.75 17.065L9.75 20.837', 'M12.75,18.185V21.3a.75.75,0,0,0,.471.7l3,1.2a.755.755,0,0,0,.557,0l3-1.2a.751.751,0,0,0,.472-.7V18.185']],
  MultipleActionsKey: ['multiple-actions-key', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M15.575,18.925a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M19.086,17.71l3.688-3.688a1.624,1.624,0,1,0-2.3-2.3L16.79,15.413a4.061,4.061,0,1,0,2.3,2.3Z']],
  MultipleActionsMobilephone: ['multiple-actions-mobilephone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.851 3.375 A2.625 2.625 0 1 0 19.101 3.375 A2.625 2.625 0 1 0 13.851 3.375 Z', 'M20.373,9a4.5,4.5,0,0,0-7.285-.71', 'M3.351 4.125 A3.375 3.375 0 1 0 10.101 4.125 A3.375 3.375 0 1 0 3.351 4.125 Z', 'M12.68,14.25a6,6,0,0,0-11.907,0', 'M19.476,19.875a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15.726 11.250 L23.226 11.250 L23.226 23.250 L15.726 23.250 Z']],
  MultipleActionsShare2: ['multiple-actions-share-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.944,11.912A6.02,6.02,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.869,8.269a4.5,4.5,0,0,0-6.757.021', 'M11.250 18.000 A2.250 2.250 0 1 0 15.750 18.000 A2.250 2.250 0 1 0 11.250 18.000 Z', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M18.750 13.500 A2.250 2.250 0 1 0 23.250 13.500 A2.250 2.250 0 1 0 18.750 13.500 Z', 'M15.424 16.845L19.074 14.655', 'M15.588 18.835L18.912 20.165']],
  MultipleActionsShare1: ['multiple-actions-share-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.218,10.513A6.076,6.076,0,0,1,23.25,14.25', 'M13.875 4.125 A3.375 3.375 0 1 0 20.625 4.125 A3.375 3.375 0 1 0 13.875 4.125 Z', 'M4.875 3.375 A2.625 2.625 0 1 0 10.125 3.375 A2.625 2.625 0 1 0 4.875 3.375 Z', 'M3.6,9a4.5,4.5,0,0,1,7.285-.71', 'M0.75 14.25L0.75 23.25', 'M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75', 'M6 18.75L9 18.75']],
  MultipleActionsSync: ['multiple-actions-sync', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M19.5 15.75L23.25 15.75 23.25 11.25', 'M23.061,15.75a6,6,0,1,0-1.122,5.242']],
  MultipleActionsMoney: ['multiple-actions-money', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,14.25H16.716a1.342,1.342,0,0,0-.5,2.587l2.063.825a1.342,1.342,0,0,1-.5,2.588H15.75', 'M17.25 14.25L17.25 13.5', 'M17.25 21L17.25 20.25', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsView: ['multiple-actions-view', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.500 15.750 A5.250 5.250 0 1 0 21.000 15.750 A5.250 5.250 0 1 0 10.500 15.750 Z', 'M23.25 23.25L19.462 19.462', 'M10.022,9.942A6.076,6.076,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsSetting: ['multiple-actions-setting', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 16.500 A1.500 1.500 0 1 0 18.750 16.500 A1.500 1.500 0 1 0 15.750 16.500 Z', 'M18.524,10.7l.442,1.453a.993.993,0,0,0,1.173.681l1.473-.342a1.339,1.339,0,0,1,1.274,2.219l-1.03,1.111a1,1,0,0,0,0,1.362l1.03,1.111a1.338,1.338,0,0,1-1.274,2.218l-1.473-.341a.992.992,0,0,0-1.173.681L18.524,22.3a1.331,1.331,0,0,1-2.549,0l-.442-1.452a.992.992,0,0,0-1.173-.681l-1.473.341a1.338,1.338,0,0,1-1.274-2.218l1.03-1.111a1,1,0,0,0,0-1.362l-1.03-1.111a1.339,1.339,0,0,1,1.274-2.219l1.473.342a.993.993,0,0,0,1.173-.681l.442-1.453A1.331,1.331,0,0,1,18.524,10.7Z', 'M10.256,10.1A6.067,6.067,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.526,7.921a4.5,4.5,0,0,0-6.414.369']],
  MultipleActionsEdit1: ['multiple-actions-edit-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.63,14.869,15,22.5l-3.75.75L12,19.5l7.63-7.631a2.116,2.116,0,0,1,2.992,0l.008.009A2.113,2.113,0,0,1,22.63,14.869Z', 'M12.75,14.25A6,6,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.888,8.29a4.5,4.5,0,0,0-6.776,0']],
  MultipleActionsRemove: ['multiple-actions-remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.5 14.999L15 19.499', 'M15 14.999L19.5 19.499', 'M10.782,10.513A6.052,6.052,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsInformation: ['multiple-actions-information', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 17.25', 'M17.25 14.31L17.25 14.31', 'M17.25,14.31a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsQuestion: ['multiple-actions-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.375,16.125A1.875,1.875,0,1,1,17.25,18', 'M17.25 20.25L17.25 20.25', 'M17.25,20.25a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375', 'M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsUpDown: ['multiple-actions-up-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.781,10.513A6.048,6.048,0,0,0,6.75,9a6,6,0,0,0-6,5.25', 'M3.375 4.125 A3.375 3.375 0 1 0 10.125 4.125 A3.375 3.375 0 1 0 3.375 4.125 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71', 'M11.25 20.25L14.25 23.25 17.25 20.25', 'M14.25 23.25L14.25 14.25', 'M17.25 17.25L20.25 14.25 23.25 17.25', 'M20.25 14.25L20.25 23.25']]
};
exports["default"] = _default;